import BaseApi from "./base-api";

class WebServiceApi extends BaseApi {
    constructor() {
        super();
    }

    /**
     *
     * @param {object} data
     * @param {string} ws
     * @returns {Promise<AxiosResponse<any>>}
     */
    payment(data, ws){
        return this._client.post(`/ecommerce/form/${ws}/payment`, data);
    }

    /**
     *
     * @param {string} transactionId
     * @param {string} paymentType
     * @returns {Promise<AxiosResponse<any>>}
     */
    transactionDetails(transactionId, paymentType){
        return this._client.get(`/ecommerce/${paymentType}/transaction/${transactionId}`);
    }
}

export default WebServiceApi;
